// extracted by mini-css-extract-plugin
export default {"actions":"CentrosEstudio_actions__BDRcX","download":"CentrosEstudio_download__L69eM","nuevo":"CentrosEstudio_nuevo__4bUfp"};